import axios from "axios";
import { USER_LIST, COUNTRY_LIST, ROLE_LIST, REGION_LIST, REGISTER, PENDING_USER_LIST, UPDATE_PENDING_USER_LIST, REJECTED_USER_LIST, SHARE_LINK } from '../../constants/api';
import { USER, MESSAGE_FOR_UPDATED, SHARE_LINK_MESSAGE } from 'src/constants/NotificationMessageConstant';
import { ShowException, ShowSuccessOrError } from '../utils/tostar';
import { history } from 'src/store/config';

export const getUserListCall = async () => {
    const resp = axios.get(USER_LIST)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getPendingUserListCall = () => {
    const resp = axios.get(PENDING_USER_LIST)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getRejectedUserListCall = () => {
    const resp = axios.get(REJECTED_USER_LIST)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const updatePendingUserListCall = (userId: any, status: any) => {
    return axios.put(UPDATE_PENDING_USER_LIST + userId + '/' + status)
        .then((res: any) => {
            ShowSuccessOrError(USER + MESSAGE_FOR_UPDATED, res);
        })
        .catch((err) => {
            ShowException(err);
        });

    // const respUser = axios.get(PENDING_USER_LIST)
    //     .then((res: any) => {
    //         return res;
    //     })
    //     .catch((err) => {
    //         ShowException(err);
    //     });
    // return respUser;
}

export const getCountryListCall = async () => {
    const resp = await axios.get(COUNTRY_LIST)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getUserRoleListCall = async () => {
    const resp = await axios.get(ROLE_LIST)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getRegionListCall = async () => {
    const resp = await axios.get(REGION_LIST)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getUserDetailsCall = async (data: any) => {
    const resp = await axios.get(USER_LIST + '/' + data.payload)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const saveUserDetailsCall = (data: any) => {
    const resp = axios.put(REGISTER, data.payload)
        .then((res: any) => {
            ShowSuccessOrError(USER + MESSAGE_FOR_UPDATED, res);
            history.push("/users");
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

// call api to share link to provided email id's
export const shareLinkByEmailApiCall = (data: any) => {
    return axios.post(SHARE_LINK, data.payload)
        .then((resp: any) => {
            ShowSuccessOrError(SHARE_LINK_MESSAGE, resp);
            return resp;
        }, (err: any) => {
            ShowException(err);
            return err;
        })
}


// WEBPACK FOOTER //
// ./src/effects/api/api.user.tsx